const wowApp = require('angular').module('oly.common');

wowApp.service('NotificationService', ['$timeout', require('./notification.service')]);

wowApp.directive('wowNotification', ['NotificationService', require('./notification.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/notification/index.js